// extracted by mini-css-extract-plugin
export default {"container":"MobileRedBall_container__n1vsx"};